var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvestmentDesc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 12L5.25 15M5.25 15L8.25 12M5.25 15V3.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2094_30527)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.3334 10.6667H12.3334C12.1566 10.6667 11.987 10.737 11.862 10.862C11.737 10.987 11.6667 11.1566 11.6667 11.3334C11.6667 11.5102 11.737 11.6798 11.862 11.8048C11.987 11.9298 12.1566 12.0001 12.3334 12.0001H13.6667C13.8436 12.0001 14.0131 12.0703 14.1382 12.1953C14.2632 12.3204 14.3334 12.4899 14.3334 12.6667C14.3334 12.8436 14.2632 13.0131 14.1382 13.1382C14.0131 13.2632 13.8436 13.3334 13.6667 13.3334H11.6667M13.0001 14.0001V10.0001M16.3334 12.0001C16.3334 13.841 14.841 15.3334 13.0001 15.3334C11.1591 15.3334 9.66675 13.841 9.66675 12.0001C9.66675 10.1591 11.1591 8.66675 13.0001 8.66675C14.841 8.66675 16.3334 10.1591 16.3334 12.0001Z",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2094_30527"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    transform: "translate(9 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvestmentDesc);
export default __webpack_public_path__ + "static/media/investmentDesc.57a4ef27b0fa1478ced22452267ba62e.svg";
export { ForwardRef as ReactComponent };